import Vue from 'vue'

export default {

  all (conditions) {
    const vendorId = conditions.vendorId

    return Vue.http.get(
      `${process.vars.BACKEND_HOST}/api/ui/products?vendor_id=${vendorId}`
    )
  },

  activeProducts () {
    return Vue.http.get(
      `${process.vars.BACKEND_HOST}/api/ui/products/?active=true`
    )
  }
}
